import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';

/**
 * Admin Route - Protects admin routes and checks for admin privileges
 */
const AdminRoute = ({ children }) => {
  const { user } = useContext(AuthContext);

  // Check if user is logged in
  if (!user) {
    return <Navigate to="/login" />;
  }

  // Admin check logic - HARDCODED ADMIN EMAIL
  const isAdmin = () => {
    const ADMIN_EMAIL = "rekhithasree@gmail.com";

    // Option 1: Check if user is superuser (if you have this info from token)
    if (user.is_superuser) {
      return true;
    }

    // Option 2: HARDCODED admin email check
    if (user.email && user.email.toLowerCase() === ADMIN_EMAIL.toLowerCase()) {
      return true;
    }

    // Option 3: Additional admin emails (add more if needed)
    const additionalAdminEmails = [
      'team@inikru.com',
      'ajithchitturi84@gmail.com',
    ];

    const emailMatch = user.email && additionalAdminEmails.includes(user.email.toLowerCase());

    return emailMatch;
  };

  if (!isAdmin()) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'Arial, sans-serif' }}>
        <h2>Access Denied</h2>
        <p>Admin access required for this page.</p>
        <button
          onClick={() => window.location.href = '/homepage'}
          style={{ padding: '10px 20px', fontSize: '16px', backgroundColor: '#2C1810', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', marginTop: '20px' }}
        >
          Return to Homepage
        </button>
      </div>
    );
  }

  return children;
};

export default AdminRoute;